/**
 * stripHtml — removes all HTML tags and decodes HTML entities from a string.
 *
 * Order matters:
 *   1. Decode entities first (&lt; → <) so encoded tags become real tags.
 *   2. Strip complete tags (<a href="...">).
 *   3. Strip truncated/unclosed tags (<a href="https://very-long-url  — no closing >).
 *   4. Collapse whitespace.
 */
export function stripHtml(str) {
  if (!str || typeof str !== "string") return str;
  return str
    .replace(/&amp;/g, "&").replace(/&lt;/g, "<").replace(/&gt;/g, ">")
    .replace(/&quot;/g, '"').replace(/&#39;/g, "'").replace(/&nbsp;/g, " ")
    .replace(/<[^>]*>/g, " ")    // complete tags
    .replace(/<[^>]*$/, " ")     // truncated / unclosed tags (no closing >)
    .replace(/\s+/g, " ").trim();
}
